package one.healthium.cali.presentation.navigation.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleEventEffect
import kotlinx.coroutines.launch
import one.healthium.cali.presentation.navigation.home.compose.AdaptiveHomeContent
import one.healthium.domain.app_visit.AppVisitCounter
import org.koin.compose.koinInject

@Composable
fun HomeContent(component: HomeComponent) {
    val appVisit = koinInject<AppVisitCounter>()
    val coroutineScope = rememberCoroutineScope()

    LifecycleEventEffect(
        event = Lifecycle.Event.ON_RESUME
    ) {
        coroutineScope.launch {
            appVisit.countAppVisit()
        }
    }

    AdaptiveHomeContent(component)
}
